import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, ClipboardListIcon, CheckIcon } from 'lucide-react';
import { HERO_BG_URL, PHONE_DISPLAY, PHONE_HREF, serviceAreas } from '../data/content';
import { useQuoteModal } from '../contexts/QuoteModalContext';
const quickPoints = ['Truck & dump trailer — one call clears it all', 'Free quote over the phone in minutes', 'We load it, haul it, and sweep up after'];
export function Hero() {
  const {
    openQuote
  } = useQuoteModal();
  return <section className="relative w-full overflow-hidden bg-forest-900" data-id="element-120" data-mp="x9urxqjzk6af">
      <img src={HERO_BG_URL} alt="Javier's pickup truck and loaded dump trailer parked on a residential driveway in North County San Diego" className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-121" data-mp="x8jj3cboo8cg" />
      <div className="absolute inset-0 bg-forest-900/85 sm:bg-forest-900/70" aria-hidden="true" data-id="element-122" data-mp="3d1a8hk3o4bda" />

      <div className="relative mx-auto max-w-6xl px-5 py-16 sm:py-20 lg:py-28" data-id="element-123" data-mp="382p73hcojln9">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-w-2xl" data-id="element-124" data-mp="384s4wnk2qj2j">
          <p className="inline-flex items-center gap-2 border-l-4 border-ember-500 pl-3 font-display text-xs uppercase tracking-[0.22em] text-ember-500 sm:text-sm" data-id="element-125" data-mp="39aur5dd7zmx8">
            Locally owned • Serving North County daily
          </p>

          <h1 className="mt-5 font-display text-4xl uppercase leading-[1.03] text-white sm:text-5xl lg:text-6xl" data-id="element-126" data-mp="30gge7hg5woha">
            Fast, reliable junk removal in{' '}
            <span className="text-ember-500" data-id="element-127" data-mp="2qkdai75nwhs8">North County San Diego</span>
          </h1>

          <p className="mt-5 text-lg leading-relaxed text-white/90 sm:text-xl" data-id="element-128" data-mp="2viokchvyisag">
            Furniture, appliances, yard waste, construction debris, full garage cleanouts — we
            show up with the truck and trailer and haul it away. Often same day.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-129" data-mp="2lmv4aoj14gnx">
            <a href={PHONE_HREF} className="inline-flex items-center justify-center gap-3 rounded-md bg-ember-500 px-7 py-4 font-display text-xl uppercase tracking-wide text-ink-900 transition-transform duration-150 ease-out hover:-translate-y-0.5 hover:bg-ember-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-130" data-mp="s2td3kfiu7p7">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-131" data-mp="dbapb0gf78va" />
              Call {PHONE_DISPLAY}
            </a>
            <button type="button" onClick={openQuote} className="inline-flex items-center justify-center gap-2 rounded-md border-2 border-white/40 px-6 py-4 font-display text-lg uppercase tracking-wide text-white transition-colors duration-150 ease-out hover:border-white hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-132" data-mp="161szsmjh4ciq">
              <ClipboardListIcon className="h-5 w-5" aria-hidden="true" data-id="element-133" data-mp="3lui8ypr8oxku" />
              Get a free quote
            </button>
          </div>

          <ul className="mt-8 space-y-2.5" data-id="element-134" data-mp="1x9b0yopm2f6r">
            {quickPoints.map(point => <li key={point} className="flex items-start gap-3 text-base text-white" data-id="element-135" data-mp="1x783xkq1jlsj">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-ember-500" data-id="element-136" data-mp="21b63fwja2ym4">
                  <CheckIcon className="h-3.5 w-3.5 text-ink-900" aria-hidden="true" data-id="element-137" data-mp="26869w8k1i3dr" />
                </span>
                {point}
              </li>)}
          </ul>

          <p className="mt-8 text-sm font-semibold uppercase tracking-wide text-white/70" data-id="element-138" data-mp="2fz0xbg90v90s">
            {serviceAreas.join(' • ')}
          </p>
        </motion.div>
      </div>
    </section>;
}